export default "__VITE_ASSET__mKAD_6hW__"